import { generateLogsContents } from './utils';
import intl from 'react-intl-universal';
import { getUserType } from 'shared/constants/users';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import logger from 'utils/logger';

const log = logger.createLogger('OrganizationLogsColumns');

const createdAtColumn = () => {
  return {
    accessorKey: 'createdAt',
    header: intl.get('logs_label_column_created_at'),
    enableSorting: true,
    enableColumnFilter: false,
    enableColumnActions: false,

    Cell: ({ renderedCellValue }) => {
      return new Date(renderedCellValue).toString();
    },
  };
};

const nameColumn = () => {
  return {
    accessorKey: 'name',
    header: intl.get('logs_label_column_user_real_name'),
    enableSorting: true,
    enableColumnFilter: false,
    enableColumnActions: false,
  };
};

const userTypeColumn = () => {
  return {
    accessorKey: 'userType',
    header: intl.get('logs_label_column_user_type'),
    enableSorting: true,
    enableColumnFilter: false,
    enableColumnActions: false,
    Cell: ({ renderedCellValue }) => {
      return getUserType(renderedCellValue);
    },
  };
};

const ipColumn = () => {
  return {
    accessorKey: 'ip',
    header: intl.get('logs_label_column_ip_address'),
    enableSorting: true,
    enableColumnFilter: false,
    enableColumnActions: false,
  };
};

const contentColumn = () => {
  return {
    accessorKey: 'content',
    header: intl.get('logs_label_column_content'),
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilter: false,
    Cell: ({ renderedCellValue }) => {
      return generateLogsContents(
        renderedCellValue.type,
        renderedCellValue.contents
      );
    },
  };
};

const viewColumn = (handleViewLog) => {
  return {
    accessorKey: 'view',
    header: intl.get('logs_label_column_details'),
    enableColumnActions: false,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ renderedCellValue }) => {
      return viewCell({ renderedCellValue, handleViewLog });
    },
  };
};

const viewCell = ({ renderedCellValue, handleViewLog }) => {
  const link = renderedCellValue;

  const isDisabled = link === '';
  return link ? (
    <div>
      <Button
        variant="contained"
        color="primary"
        disabled={isDisabled}
        onClick={() => {
          handleViewLog(link);
        }}>
        {intl.get('logs_button_view')}
      </Button>
    </div>
  ) : (
    <></>
  );
};

viewCell.propTypes = {
  renderedCellValue: PropTypes.string,
  handleViewLog: PropTypes.func.isRequired,
};

export const getOrganizationLogsColumns = (handleViewLog) => {
  return [
    createdAtColumn(),
    nameColumn(),
    userTypeColumn(),
    ipColumn(),
    contentColumn(),
    viewColumn(handleViewLog),
  ];
};
